/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Interaccountingemail32Inputs */

const en__field_interaccountingemail32 = /** @type {(inputs: _Field_Interaccountingemail32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`internal accounting e-mail 3`)
};

const de__field_interaccountingemail32 = /** @type {(inputs: _Field_Interaccountingemail32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interne Accounting E-Mail 3`)
};

/**
* | output |
* | --- |
* | "internal accounting e-mail 3" |
*
* @param {_Field_Interaccountingemail32Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_interaccountingemail32 = /** @type {((inputs?: _Field_Interaccountingemail32Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Interaccountingemail32Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_interaccountingemail32(inputs)
	return de__field_interaccountingemail32(inputs)
});
export { _field_interaccountingemail32 as "_field_interAccountingEmail3" }